import { Paginazione } from './../../shared/models/paginazione';
export class FiltriProdotto extends Paginazione{
  prodotto: string;
  cat_id: number;
  ruolo: string;
  orderByNome: string;
  parte: string;
  tipo?: number;
  constructor(prodotto: string, page?, size?, cat_id?:number, orderByNome?: string) {
    super(page || 0, size || 1);
    this.prodotto = prodotto;
    this.parte = prodotto;
    this.cat_id = cat_id;
    this.orderByNome = orderByNome;
  }
}
